import { render, staticRenderFns } from "./parBoutique.vue?vue&type=template&id=e40212f6&"
import script from "./parBoutique.vue?vue&type=script&lang=js&"
export * from "./parBoutique.vue?vue&type=script&lang=js&"
import style0 from "./parBoutique.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports